<template>
	<div class="notificationContainer">
      <v-flex v-if="objAuthorize.department_active == 1" class="filterNotificationsDeps">
        <!--<v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />-->
        <v-select @input="fncFilterNotifications()" class="shortSelect" v-model="filterDepartment" :items="departmentListSet" item-text="name" item-value="id" solo outline></v-select><br />
      </v-flex>
		<v-data-table loading="true" :headers="headers" :items="statusListSet" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr class="sortableRow" id="rows" v-if="props.item.show == true">
					<td width="70%">{{ props.item.description }}</td>
					<td width="20%">{{ fncGetCount(props.item.id) }}</td>
					<td width="10%"><a @click.prevent="fncShowNotifications(props.item)"><i class="material-icons">add_alert</i></a></td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import {departmentList} from "../../store/modules/departments/getters";
  import {newReportFilters} from "../../store/modules/reports/getters";

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {
			search: '',
      departmentListSet: [],
      statusListSet: [],
      filterDepartment: window.localStorage.notificationDepartment != undefined && window.localStorage.notificationDepartment != null ? parseInt(window.localStorage.notificationDepartment) : '',
            headers: [
              { text: 'Status', value: 'description', width: '70%' },
              { text: 'Total Notifications', value: 'description', width: '20%' },
              { text: 'Set Notifications', value: 'description', width: '10%' },
            ]
		}
	},
	methods: {
    fncFilterNotifications() {

      // set local storage for department filter
      localStorage.setItem('notificationDepartment', this.filterDepartment);

      window.location.reload();

      /*var newStatusList = [];
      if( this.filterDepartment == '' ) {
        this.statusListSet = this.statusList;
      } else {
        for( var s in this.statusList ) {
          if( this.statusList[s].department != null ) {
            var splitDeps = this.statusList[s].department.split(',');
            for( var sd in splitDeps ) {
              splitDeps[sd] = parseInt( splitDeps[sd] );
            }
            if( splitDeps.indexOf( this.filterDepartment ) != -1 ) {
              //this.statusListSet[s].show = true;
              newStatusList.push( this.statusListSet[s] );
            }
          }
        }
        this.statusListSet = newStatusList;

      }*/
    },
      fncGetCount( statusId ) {
        var n = 0;
        for( var s in this.statusCount ) {
          if( this.statusCount[s].status_id == statusId ) {
            n++;
          }
        }
        return n;
      },
      fncShowNotifications(status) {

        var subFilter = '';
        var subCheck = localStorage.getItem('notificationSubDepartment');

        if( subCheck != '' ) {
          subFilter = subCheck;
        }

        status.subFilter = subFilter

        this.$store.dispatch('fncGetStatusNotifications', status);
		}
	},
	computed: {
		...mapGetters([
			'objAuthorize',
      'statusList',
			'statusCount',
      'departmentList'
		])
	},
	beforeMount() {
      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncPopulateStatusList');
      this.$store.dispatch('fncPopulateStatusCount');
      this.$store.dispatch('fncPopulateVendorLinksNotifications');
	},
	mounted () {
    this.departmentListSet = [];
    this.departmentListSet.push({id: '', name: 'All Departments'});
    for( var d in this.departmentList ) {
      this.departmentListSet.push({id: this.departmentList[d].id, name: this.departmentList[d].name});
    }
    if( isNaN(this.filterDepartment) ) {
      this.filterDepartment = '';
    }
  },
  watch: {
	  departmentList() {
	    this.departmentListSet.push({id: '', name: 'All Departments'});
	    for( var d in this.departmentList ) {
        this.departmentListSet.push({id: this.departmentList[d].id, name: this.departmentList[d].name});
      }
    },
    statusList() {
        if( this.filterDepartment != '' && this.filterDepartment != 'NaN' && !isNaN(this.filterDepartment) ) {
          var newStatusList = [];
          for( var s in this.statusList ) {
            if( this.statusList[s].department != null ) {
              var splitDeps = this.statusList[s].department.split(',');
              for( var sd in splitDeps ) {
                splitDeps[sd] = parseInt( splitDeps[sd] );
              }
              if( splitDeps.indexOf( this.filterDepartment ) != -1 ) {
                //this.statusListSet[s].show = true;
                newStatusList.push( this.statusList[s] );
              }
            }
          }
          this.statusListSet = newStatusList;
        } else {
          for( var s in this.statusList ) {
            this.statusListSet.push({id: this.statusList[s].id, description: this.statusList[s].description, show: this.statusList[s].show, department: this.statusList[s].department});
          }
        }
    }
  }
}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
